module.exports = __webpack_public_path__ + "static/media/recurrencePatterns_01.ba46f5b9.jpg";